// Imports
import React from 'react'
import PropTypes from 'prop-types'

// Component
const Input = (props) => {
  const { type, fullWidth, placeholder, value, minWidth, error, ...other } = props

  const style = {
    'backgroundColor' : 'transparent',
    'border' : 'none',
    'borderBottom' : error ? '2px solid red' : '1px solid #ccc',
    'fontSize': '1em',
    'paddingTop': '.8em',
    'paddingBottom': '.4em',
    'fontFamily': 'Foco-Regular'
  }

  style.minWidth = minWidth ? minWidth : '300px';

  return (
    <div className="group">
      <input type={type} {...other} style={style} value={value} />
      <label className={value ? 'valid' : ''}>{placeholder}</label>
    </div>
  )
}

// Component Properties
Input.propTypes = {
  type: PropTypes.string,
  fullWidth: PropTypes.bool
}
Input.defaultProps = {
  type: 'button',
  fullWidth: false
}

export default Input


// WEBPACK FOOTER //
// ./src/ui/input/Input.js